export default __webpack_public_path__ + "static/media/m8.3a70edbf.jpg";